// src/utils/search.ts

// Wyszukiwarki na ekranie z listami i na ekranie katalogu obrazów. Liczą się tylko litery i cyfry:
// apostrof znika („dont" znajdzie „don't"), a nawias, przecinek, ukośnik czy myślnik dzieli słowa jak
// spacja — i w tym, co wpisano, i w tym, co przeszukujemy. Znaki zerowej szerokości z kopiowanego tekstu
// też znikają, żeby nie rozcinały słów.
export const toSearchWords = (text?: string | null): string[] => (text ?? '')
  .normalize('NFC')
  .toLowerCase()
  .replace(/[\u{200B}-\u{200D}\u{2060}\u{FEFF}'\u{2018}\u{2019}\u{02BC}`\u{00B4}]/gu, '')
  .replace(/[^\p{L}\p{N}]+/gu, ' ')
  .split(' ')
  .filter(Boolean);

// Każde wpisane słowo ma być fragmentem tekstu, w dowolnej kolejności — „inter music" znajdzie
// „be interested in (music)". Pusta lista słów (puste pole, same znaki) nie odsiewa niczego.
export const matchesSearch = (text: string, searchWords: string[]): boolean => {
  const searchable = toSearchWords(text).join(' ');

  return searchWords.every((word) => searchable.includes(word));
};
